import PaginationLayout from "../components/PaginationLayout";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { Link, useLocation, useMatch } from "react-router-dom";
import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getUserProfileImage } from "../utils/constant_value";

function UserMessage() {
  const navigate = useNavigate();
  const location = useLocation();
  const match=useMatch("/user-Messages/:page")
  let limit = 10;
  const { authState,handleError, handlePagination, handleFilter } = useContext(GlobalContext);
  const param = useParams();
  const newParam = new URLSearchParams(location?.search);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  henceforthApi.setToken(authState?.access_token);

  // const onChangePagination = (newVal) => {
  //   const newParam = new URLSearchParams(location?.search);
  //   if (newParam.has("search")) {
  //     navigate(`/user-Messages/${newVal}?search=${newParam?.get("search")}`);
  //   } else {
  //     navigate(`/user-Messages/${newVal}`);
  //   }
  // };

  //Message

  var query = new URLSearchParams(location?.search);
  const [getQueries, setGetQueries] = useState([]);
  const queriesData = async () => {
    try {
      setLoading(true)
      let q = query?.toString();
      const getApi = await henceforthApi?.Queries?.queriesUser(Number(match.params.page)-1,limit,query.toString());
      setGetQueries(getApi?.user_messages);
      setTotalCount(getApi?.count)
      setLoading(false)
    } catch (error) {
      handleError(error)
      setLoading(false)
    }
   
  };

  //Filter
  const filters = [
    { name: "Replied_Message", value: "Replied_Message" },
    { name: "UnReplied_Message", value: "UnReplied_Message" },
    { name: "Read_Message", value: "Read_Message" },
    { name: "UnRead_Message", value: "UnRead_Message" },

  ];
  // const onFilterApply = (name, value) => {
  //   setLoading(true);
  //   if (query?.has(name)) {
  //     let queryValue = query?.get(name);
  //     // if (queryValue == value) {
  //     if (value === "") {
  //       query?.delete(name);
  //     } else {
  //       query?.set(name, value);
  //     }
  //   } else {
  //     query?.set(name, value);
  //   }
  //   setLoading(false)
  //   navigate({ pathname: `/user-Messages/1`, search: query.toString() }, { replace: true });
  // };

  useEffect(() => {
    queriesData();
  }, [query?.get("filter"), match.params.page]);
  return (
    <>
      <div className="ibox animated fadeInRight">
        <div
          className="ibox-title d-flex align-items-center justify-content-between"
          style={{ color: "#000000" }}
        >
          <h5>List of all Users Messages</h5>

          <div className="dropdown theme me-3">
            <button
              className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
              id="sortDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filters?.filter((res) => res?.value == query?.get("filter")).length
                ? filters?.filter((res) => res?.value === query?.get("filter"))[0]
                  .name?.split("_")?.join(" ")
                : "All"}
              {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
            </button>
            <ul
              className="dropdown-menu share-icons"
              aria-labelledby="sortDropdown"
            >
              {query?.has("filter") && (
                <li className="cursor-pointer">
                  <a
                    className="dropdown-item"
                    onClick={() => handleFilter("filter", "")}
                  >
                    All
                  </a>
                </li>
              )}
              {filters?.map((res) => {
                return (
                  <li key={res?.value} className="cursor-pointer">
                    <a
                      className="dropdown-item"
                      onClick={() => handleFilter("filter", res?.value)}
                    >
                      {res?.name?.split("_").join(" ")}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="ibox-content">
          <div className="table-responsive">
            <table className="table table-striped" style={{ whiteSpace: 'nowrap' }}>
              <thead>
                <tr style={{ color: "#000000", fontSize: "14px" }}>
                  <th>Sr. No.</th>
                  <th>Profile</th>
                  <th>Name</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Date & Time</th>
                  <th>Message</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {!loading && !getQueries?.length ? <tr>
                  <td colSpan={9}>
                     <div className="text-center"> <b >No message Found </b> </div> 
                  </td>
                </tr> : getQueries?.map((res, index) => (
                  <tr key={index} style={{ fontSize: "14px" }}>
                    <td>
                      {param?.page === "0"
                        ? index + 1
                        : (param.page - 1) * limit + (index + 1)}
                      .
                    </td>
                    <td className="justify-content-center">
                      {" "}
                      <img
                        src={getUserProfileImage(res?.user_id?.profile_pic)}
                        className="me-2 imageSize"
                        alt="Profile"
                      />
                    </td>
                    <td>{res?.user_id?.full_name ? res?.user_id?.full_name :"Not available" }</td>
                    <td>{res?.user_id?.username ? res?.user_id?.username : "Not available"}</td>
                    <td>{res?.user_id?.email ? res?.user_id?.email: "Not available"}</td>
                    <td>{res?.phone_no ? res?.phone_no : "Not available"}</td>
                    <td>
                      {" "}
                      {moment(Number(res?.created_at)).format("DD MMM YYYY, h:mm a")}
                    </td>
                    <td >
                      <div
                        className="userMessageLength align-items-center"
                      > {res?.message.length > 25 ? res?.message?.slice(0,25) + "..." : res?.message}</div>
                    </td>
                    <td>
                      <div className="d-flex">
                        <Link
                          getQueries={getQueries}
                          style={{ fontSize: "14px" }}
                          to={`/user-Message-Details/${res?._id}`}
                          className="btn btn-xs btn-white me-2"
                        >
                          <i className="fas fa-eye me-1"></i>
                          View
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
          <PaginationLayout
            count={totalCount}
            data={getQueries}
            page={Number(match.params.page)}
            limit={Number(limit)}
            loading={loading}
            onPageChange={(val) => handlePagination(val)}
          />
        </div>
      </div>
    </>
  );
}
export default UserMessage;
